import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';

//import components
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import AboutPblMenu from '../components/about/AboutPblMenu.js';
import LoadingIndicator from '../components/LoadingIndicator.js';
import Error505Page from '../components/Error505Page.js';
import AboutPblItem from '../components/about/subpages/AboutPblItem.js';
import Error404Page from '../components/Error404Page.js';

import withTitle from '../scripts/WithTitle.js';
import menuItems from '../scripts/AboutSubpages.js';

class AboutPbl extends Component {
    constructor() {
        super();

        this.state = {
        };
    };

    componentDidMount() {
        const { actions, clang, match } = this.props;

        this.flattenArr(menuItems);
        actions.getAboutPblSubpage(match.params.type, clang);
        actions.getAboutPblExamples(clang);
    };

    componentDidUpdate(prevProps) {
        const { actions, clang, match, location, pageData, history } = this.props;

        if (location !== prevProps.location || clang !== prevProps.clang) {
            actions.getAboutPblSubpage(match.params.type, clang);
            actions.getAboutPblExamples(clang);
        }

        const isExample = match.params.type === 'examples' && match.params.id;

        if (isExample && pageData) {
            this.updateItemData(pageData, match, clang, prevProps.clang, history);
        }
    };

    updateItemData = (pageData, match, clang, prevClang, history) => {
        const isInPageData = pageData.data.filter(dataItem => dataItem.id === parseInt(match.params.id, 10)).length > 0;

        if (!this.state.itemData || isInPageData) {
            const itemData = pageData.data.filter(dataItem => dataItem.id === parseInt(match.params.id, 10))[0];
            if (itemData && (!this.state.itemData || itemData.id !== this.state.itemData.id )) {
                this.setState({itemData: itemData});
            } else if (!isInPageData) {
                history.push({
                    pathname: `/about/${match.params.type}`
                });
            }
        }

        if (clang !== prevClang && this.state.itemData && this.state.itemData.acf.query_id_in_other_language) {
            history.push({
                pathname: `/about/${match.params.type}/${this.state.itemData.acf.query_id_in_other_language}`
            });
        }
    };

    menuItemsFlattened = [];

    flattenArr = (arr) => {
        const that = this;

        arr.forEach(function(item) {
            that.menuItemsFlattened.push(item);
            if (item.children && item.children.length) {
                that.flattenArr(item.children);
            }
        });
    };

    getSubpageComponent = () => {
        const { pageData, pageDataExamples, match} = this.props;

        const ItemComponent = this.menuItemsFlattened.filter(item => item.name === match.params.type)[0].component;
        return <ItemComponent pageData={pageData} pageDataExamples={pageDataExamples} id={match.params.type} />;
    };

    render() {
        const { clang, pageData, pageDataExamples, isLoadingError, isFetching, match, location, showBackButton } = this.props;
        const {itemData} = this.state;
        if (!this.menuItemsFlattened.map(item => item.name).includes(match.params.type) || (match.params.type !== 'examples' && match.params.id)) {
            return (
                <Error404Page location={location}/>
            );
        }

        const isExample = match.params.type === 'examples' && match.params.id;

        if (isExample && itemData) {
            const breadcrumbsList = [{label: 'home'}, {label: 'about-pbl', link: '/about'}, {label: lang[clang].about_pbl[match.params.type], link: `/about/${match.params.type}`}];

            return(
                <section className="about-pbl">
                    <ItemBreadcrumbs list={breadcrumbsList} currentPage={itemData.title.rendered}/>
                    <div className="about-pbl__container">
                        <aside className="about-pbl__menu-container">
                            <AboutPblMenu items={menuItems} />
                        </aside>
                        <AboutPblItem data={itemData} showBackButton={showBackButton} match={match}/>
                    </div>
                </section>
            )
        }


        if (isExample && !itemData) {
            const breadcrumbsList = [{label: 'home'}, {label: 'about-pbl', link: '/about'}];

            return(
                <section className="about-pbl">
                    <ItemBreadcrumbs list={breadcrumbsList} currentPage={lang[clang].about_pbl[match.params.type]}/>
                    <div className="about-pbl__container">
                        <aside className="about-pbl__menu-container">
                            <AboutPblMenu items={menuItems} />
                        </aside>
                        {isLoadingError &&
                            <article className="about-pbl__subpage">
                                <Error505Page />
                            </article>}
                        {!isLoadingError && (isFetching || !pageData) &&
                            <article className="about-pbl__subpage">
                                <LoadingIndicator/>
                            </article>}
                    </div>
                </section>
            )
        }

        const breadcrumbsList = [{label: 'home'}, {label: 'about-pbl', link: '/about'}];

        return (
            <section className="about-pbl">
                <ItemBreadcrumbs list={breadcrumbsList} currentPage={lang[clang].about_pbl[match.params.type]}/>

                <div className="about-pbl__container">
                    <aside className="about-pbl__menu-container">
                        <AboutPblMenu items={menuItems} />
                    </aside>

                    {isLoadingError &&
                        <article className="about-pbl__subpage">
                            <Error505Page />
                        </article>}

                    {!isLoadingError && (isFetching || !pageData) &&
                        <article className="about-pbl__subpage">
                            <LoadingIndicator/>
                        </article>}

                    {!isLoadingError && !isFetching && pageData && pageDataExamples &&
                        <article className="about-pbl__subpage">
                            <div className="about-pbl__subpage-content">{this.getSubpageComponent()}</div>
                        </article>}
                </div>
            </section>
        );
    };
};

AboutPbl.propTypes = {
    clang: propTypes.string.isRequired,
    actions: propTypes.object.isRequired,
    pageData: propTypes.object,
    pageDataExamples: propTypes.object,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    pageData: state.aboutPbl.pageData,
    pageDataExamples: state.aboutPbl.pageDataExamples,
    isFetching: state.aboutPbl.isFetching,
    isLoadingError: state.aboutPbl.isLoadingError,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(AboutPbl);



// WEBPACK FOOTER //
// ./src/containers/AboutPbl.js